<template>
  <div class="makeup-approval">
    <el-card class="approval-card">
      <div slot="header" class="card-header">
        <span>补考审批</span>
      </div>



      <!-- 补考申请表格 -->
      <el-table
        v-loading="loading"
        :data="applications"
        border
        style="width: 100%"
        class="applications-table"
      >
        <el-table-column prop="id" label="序号" width="80">
          <template #default="scope">
            {{ scope.row.id || scope.row.makeupId || '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="studentName" label="学生姓名" width="150"></el-table-column>
        <el-table-column prop="studentId" label="学生ID" width="150"></el-table-column>
        <el-table-column prop="itemName" label="测试项目" width="180"></el-table-column>
        <el-table-column prop="applyTime" label="申请时间" width="180">
          <template #default="scope">
            {{ formatDate(scope.row.applyTime) }}
          </template>
        </el-table-column>
        <el-table-column prop="testDate" label="补考时间" width="180">
          <template #default="scope">
            {{ formatDate(scope.row.testDate) || '-' }}
          </template>
        </el-table-column>
        <el-table-column label="状态" width="150">
          <template #default="scope">
            <el-tag :type="getStatusType(scope.row.status)">
              {{ getStatusText(scope.row.status) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="补考原因" min-width="200">
          <template #default="scope">
            <div class="reason-content" :title="scope.row.reason || scope.row.applyReason || scope.row.makeupReason || '-'">
              {{ scope.row.reason || scope.row.applyReason || scope.row.makeupReason || '-' }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="操作" min-width="120">
          <template #default="scope">
            <el-button type="primary" size="small" @click="showApprovalDialog(scope.row)">审批</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <div class="pagination-container">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50]"
          :page-size="pageSize"
          :total="total"
          layout="total, sizes, prev, pager, next, jumper"
        ></el-pagination>
      </div>
    </el-card>

    <!-- 申请详情对话框 -->
    <el-dialog v-model="detailVisible" title="补考申请详情" width="600px">
      <el-descriptions :column="1" border>
        <el-descriptions-item label="学生信息">{{ currentApplication.studentName }} (学号：{{ currentApplication.studentNumber }}，ID：{{ currentApplication.studentId }})</el-descriptions-item>
        <el-descriptions-item label="体测项目">{{ currentApplication.itemName }}</el-descriptions-item>
        <el-descriptions-item label="原测试日期">{{ currentApplication.testDate }}</el-descriptions-item>
        <el-descriptions-item label="原成绩">{{ currentApplication.originalScore }} ({{ currentApplication.originalGrade }})</el-descriptions-item>
        <el-descriptions-item label="申请时间">{{ currentApplication.applyTime }}</el-descriptions-item>
        <el-descriptions-item label="补考原因">
          {{ currentApplication.reason || '-' }}
          <!-- 添加调试信息 -->
          <div v-if="false" style="font-size: 12px; color: #909399; margin-top: 5px;">
            调试信息: reason={{ currentApplication.reason }}, applyReason={{ currentApplication.applyReason }}, makeupReason={{ currentApplication.makeupReason }}
          </div>
        </el-descriptions-item>
        <el-descriptions-item label="审批状态">{{ getStatusText(currentApplication.status) }}</el-descriptions-item>
        <el-descriptions-item label="审批意见" v-if="currentApplication.approvalOpinion">{{ currentApplication.approvalOpinion }}</el-descriptions-item>
        <el-descriptions-item label="审批时间" v-if="currentApplication.approvalTime">{{ currentApplication.approvalTime }}</el-descriptions-item>
      </el-descriptions>
      <template #footer>
        <el-button @click="detailVisible = false">关闭</el-button>
      </template>
    </el-dialog>

    <!-- 审批对话框 -->
    <el-dialog v-model="approvalVisible" title="审批补考申请" width="500px">
      <el-form
        ref="formRef"
        :model="approvalForm"
        :rules="approvalRules"
        label-width="100px"
        size="default"
      >
        <el-form-item label="当前状态">
          <el-tag :type="getStatusType(currentApplication.status)">
            {{ getStatusText(currentApplication.status) }}
          </el-tag>
        </el-form-item>
        <el-form-item label="审批结果" prop="status">
          <el-select v-model="approvalForm.status" placeholder="请选择审批结果" @change="handleStatusChange">
            <el-option value="已批准" label="已批准"></el-option>
            <el-option value="已拒绝" label="已拒绝"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="审批意见" prop="opinion">
          <el-input
            v-model="approvalForm.opinion"
            type="textarea"
            rows="4"
            placeholder="请输入审批意见"
            debounce="0"
            @input="forceUpdateDOM"
          ></el-input>
        </el-form-item>
        <el-form-item label="补考日期" prop="makeupDate" v-if="approvalForm.status === '已批准'">
          <el-date-picker
            v-model="approvalForm.makeupDate"
            type="date"
            format="YYYY-MM-DD"
            value-format="YYYY-MM-DD"
            placeholder="选择补考日期"
            @change="forceUpdateDOM"
          ></el-date-picker>
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="approvalVisible = false">取消</el-button>
        <el-button type="primary" :loading="submitting" @click="submitApproval">提交</el-button>
      </template>
    </el-dialog>

  </div>
</template>

<script setup>
import { ref, reactive, onMounted, getCurrentInstance, markRaw, nextTick } from 'vue';
import { ElMessage } from 'element-plus';
import request from '@/utils/request';
import { useAuthStore } from '@/store/modules/auth';

const authStore = useAuthStore();

const { proxy } = getCurrentInstance();

// 加载状态
const loading = ref(false);
// 提交状态
const submitting = ref(false);

// 表格数据
const applications = ref([]);
const total = ref(0);
const currentPage = ref(1);
const pageSize = ref(10);

// 对话框状态
const detailVisible = ref(false);
const approvalVisible = ref(false);
const currentApplication = ref({});

// 表单引用
const formRef = ref(null);

// 审批表单 - 使用reactive包装以提高响应性
const approvalForm = reactive({
  status: '',
  opinion: '',
  makeupDate: ''
});

// 审批表单验证规则
const approvalRules = {
  status: [
    { required: true, message: '请选择审批结果', trigger: 'change' }
  ],
  opinion: [
    { required: true, message: '请输入审批意见', trigger: 'blur' },
    { min: 1, message: '意见长度不能少于1个字符', trigger: 'blur' }
  ],
  makeupDate: [
    {
      validator: (rule, value, callback) => {
        if (approvalForm.status === '已批准' && !value) {
          callback(new Error('请选择补考日期'));
        } else {
          callback();
        }
      },
      trigger: 'change'
    }
  ]
};

// 强制Vue更新DOM
const forceUpdateDOM = async () => {
  await nextTick();
  // 触发重新渲染
  if (proxy && proxy.$forceUpdate) {
    proxy.$forceUpdate();
  }
};

// 获取状态文本 - 使用markRaw避免不必要的响应式转换
const getStatusText = markRaw((status) => {
  switch (status) {
    case 'PENDING': return '未审批';
    case 'APPROVED': return '已批准';
    case 'REJECTED': return '已拒绝';
    case 'COMPLETED': return '已完成';
    case 'INCOMPLETE': return '未完成';
    case '已完成': return '已完成';
    case '未完成': return '未完成';
    case '未审批': return '未审批';
    default: return status;
  }
});

// 获取状态样式 - 使用markRaw避免不必要的响应式转换
const getStatusType = markRaw((status) => {
  switch (status) {
    case 'PENDING': return 'warning';
    case 'APPROVED': return 'success';
    case 'REJECTED': return 'danger';
    case 'COMPLETED': return 'success';
    case 'INCOMPLETE': return 'warning';
    case '已完成': return 'success';
    case '未完成': return 'warning';
    case '未审批': return 'warning';
    case '已拒绝': return 'danger';
    case '已批准': return 'success';
    default: return '';
  }
});

// 格式化日期，只显示年月日
const formatDate = (dateString) => {
  if (!dateString) return '-';
  try {
    // 处理ISO格式日期
    if (dateString.includes('T')) {
      return dateString.split('T')[0];
    }
    // 处理普通格式日期
    return dateString.split(' ')[0];
  } catch (error) {
    console.error('日期格式化错误:', error);
    return '-';
  }
};

// 处理状态变更
const handleStatusChange = async () => {
  // 当审批结果改变时，强制Vue更新DOM
  if (approvalForm.status === '已批准') {
    // 保持原有日期值
  } else {
    approvalForm.makeupDate = '';
  }
  await forceUpdateDOM();
};

// 获取补考申请列表
const fetchApplications = async () => {
  try {
    loading.value = true;
    const params = {
      page: currentPage.value,
      pageSize: pageSize.value
    };

    const response = await request.get('/teacher/makeup-applications', params);
    // 根据实际数据结构正确赋值
    applications.value = response.data?.data || [];
    total.value = response.data?.total || 0;
  } catch (error) {
    console.error('获取补考申请失败:', error);
    ElMessage.error('获取补考申请失败');
  } finally {
    loading.value = false;
  }
};

// 分页处理
const handleSizeChange = (size) => {
  pageSize.value = size;
  currentPage.value = 1;
  fetchApplications();
};

const handleCurrentChange = (page) => {
  currentPage.value = page;
  fetchApplications();
};

// 查看详情
const viewDetails = (application) => {
  // 创建新对象以避免直接修改原数据
  currentApplication.value = { ...application };
  // 增强调试日志，记录收到的完整申请数据
  console.log('查看申请详情，完整数据:', application);
  // 尝试多种可能的字段名获取补考原因
  const reason = application.reason || application.applyReason || application.makeupReason || '-';
  currentApplication.value.reason = reason;
  detailVisible.value = true;
};

// 显示审批对话框
const showApprovalDialog = (application) => {
  // 创建新对象以避免直接修改原数据
  currentApplication.value = { ...application };
  // 重置表单
  // 状态映射：英文 -> 中文
  const statusMap = {
    'PENDING': '未审批',
    'APPROVED': '已批准',
    'REJECTED': '已拒绝'
  };
  approvalForm.status = statusMap[application.status] || application.status || '未审批';
  approvalForm.opinion = '';
  approvalForm.makeupDate = application.makeupDate || '';
  approvalVisible.value = true;
};

// 提交审批
const submitApproval = async function() {
  // 获取表单引用
  const form = formRef.value;
  if (!form) {
    ElMessage.error('表单引用错误');
    return;
  }
  
  // 使用validate立即验证
  try {
    await form.validate();
  } catch (error) {
    console.error('表单验证失败:', error);
    return; // 验证失败直接返回，不再继续执行
  }

  submitting.value = true;

  // 状态映射：中文 -> 英文
  const statusMap = {
    '已批准': 'APPROVED',
    '已拒绝': 'REJECTED',
    '未审批': 'PENDING'
  };
  // 确保即使表单状态是英文的也能正确处理
  const apiStatus = statusMap[approvalForm.status] || approvalForm.status;
  
  // 根据审批结果选择不同的API接口
  const endpoint = approvalForm.status === '已批准' ? 'approve' : 'reject';
  
  // 获取正确的补考ID - 尝试多种可能的ID字段
  let makeupId = '';
  if (currentApplication.value && (currentApplication.value.id || currentApplication.value.makeupId)) {
    makeupId = currentApplication.value.id || currentApplication.value.makeupId;
    console.log('使用的补考ID:', makeupId);
  } else {
    ElMessage.error('未找到有效的补考ID');
    submitting.value = false;
    return;
  }
  
  // 构建请求数据
  const requestData = {
    makeupId: makeupId,
    opinion: approvalForm.opinion, // 添加审批意见字段
    // 只有批准时且日期不为空时才包含日期信息
    ...(apiStatus === 'APPROVED' && approvalForm.makeupDate && {
      // 确保日期格式为YYYY-MM-DD，与后端期望格式匹配
      makeupDate: approvalForm.makeupDate.replace(/T.*$/, '') + ' 00:00:00'
    })
  };

  console.log('提交审批请求数据:', requestData);
  console.log('提交到端点:', `/teacher/makeup-application/${endpoint}`);
  console.log('当前用户token:', authStore.token ? authStore.token.substring(0, 20) + '...' : '无token');
  console.log('当前用户角色:', authStore.role);
  
  try {
      // 为拒绝请求添加更明确的请求数据结构
      const finalRequestData = {
        ...requestData,
        // 确保status字段在所有请求中都存在
        status: approvalForm.status
      };
      
      console.log('最终提交数据:', finalRequestData);
      const response = await request.post(`/teacher/makeup-application/${endpoint}`, finalRequestData);
      
      if (response.data && response.data.success) {
        ElMessage.success('审批操作成功');
        approvalVisible.value = false;
        // 重置提交状态
        setTimeout(() => {
          fetchApplications();
        }, 100); // 小幅延迟以确保UI更新
      } else {
        ElMessage.error(response.data?.message || '审批操作失败');
      }
    } catch (error) {
      console.error('提交审批失败:', error);
      console.error('错误详情:', error.response || error);
      // 增强错误处理，显示更详细的错误信息
      if (error.response && error.response.data && error.response.data.message) {
        ElMessage.error(`审批操作失败: ${error.response.data.message}`);
      } else {
        ElMessage.error('审批操作失败，请稍后重试');
      }
    } finally {
      submitting.value = false;
    }
};

onMounted(() => {
  fetchApplications();
});
</script>

<style scoped>
.makeup-approval {
  padding: 10px 0;
}

.filter-container {
  margin-bottom: 20px;
  padding: 15px;
  background-color: #f9f9f9;
  border-radius: 4px;
}

.applications-table {
  margin-bottom: 20px;
  --el-table-row-height: 80px; /* 与学生管理页面一致的行高 */
}

/* 增大标题和表格之间的间距 */
.approval-card >>> .el-card__header {
  margin-bottom: 30px; /* 增加标题下方的间距 */
}

/* 或者通过设置表格的上边距来增加间距 */
.applications-table {
  margin-top: 30px;
}

.pagination-container {
  display: flex;
  justify-content: flex-end;
  margin-top: 15px;
}

/* 优化表单元素的交互体验 */
.el-input__inner {
  transition: border-color 0.2s ease-in-out;
}

.el-select .el-input__inner {
  cursor: pointer;
}

/* 确保已拒绝状态显示为红色背景 */
.makeup-approval .el-tag.danger {
  background-color: #f56c6c !important;
  color: #fff !important;
  border-color: #f56c6c !important;
}

/* 确保已批准状态显示为绿色背景 */
.makeup-approval .el-tag.success {
  background-color: #67c23a !important;
  color: #fff !important;
  border-color: #67c23a !important;
}
</style>